import React, { Component, } from 'react';
import autobind from 'autobind-decorator'
import TSelect from '../common/TSelect';
import TButton from '../common/TButton';
import TColorPicker from '../common/TColorPicker';
import TImageSelect from '../common/TImageSelect';
import ReactSlider from 'react-slider';
import classnames from 'classnames';
import { connect } from "react-redux";
import { jsonResponseHandler } from '../../utils/FetchHelper'
import {addPrefix} from "../../utils/UriUtil";

@connect(state => ({}), dispatch => ({
  dispatch
}))
class MenubarForm extends Component {
  constructor(props) {
    super(props);
    const hideMenubar = (props.selected.hideMenubar == "1");

    this.state = {
      optionList: props.optionList,
      initialSelected: props.selected,
      selected: props.selected,
      changed: {},
      hideMenubar: hideMenubar
    };
  }

  @autobind
  handleChangeHideMenubar(property, value) {
    this.changeSelection(property, value)
    this.setState({
      hideMenubar: value == "1"
    })
  }

  @autobind
  changeSelection(property, value) {

    const { selected, changed } = this.state;
    let diff = {};
    diff[property] = value;

    this.setState({
      selected: Object.assign({}, selected, diff),
      changed: Object.assign({}, changed, diff),
    });

  }

  @autobind
  handleSave(callback, failCallback) {

    const { dispatch } = this.props;

    fetch(addPrefix("/manage/design/setting.json"),
      {
        method: 'put',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.state.changed)
      })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        callback();
        this.setState({
          initialSelected: this.state.selected
        });
      })
      .catch(e => {
        console.log(e);
        failCallback();
      });
  }

  @autobind
  handlePreview() {
    let selected= this.state.selected;
    let hideMenubar = selected['hideMenubar'];
    let type = selected['menubarType'];
    window.open(`/manage/previewMenubar.php?hideMenubar=${hideMenubar}&type=${type}`, '_blank');
  }

  render() {
    const { optionList, initialSelected, selected } = this.state;

    return (
      <form className="wrap_set">
        <fieldset>
          <legend className="screen_out">메뉴바 설정</legend>
          <div className="item_set">
            블로그 메뉴바를
						<TSelect defaultClassName={'opt_set opt_decoset7'} selectItem={this.handleChangeHideMenubar} propertyName={"hideMenubar"} selected={selected} optionList={optionList} />
          </div>
          {!this.state.hideMenubar && (
            <div className="item_set">
              메뉴바는
						<TSelect defaultClassName={'opt_set opt_decoset7'} selectItem={this.changeSelection} propertyName={"menubarType"} selected={selected} optionList={optionList} />
              에 위치합니다.
					</div>
          )}
        </fieldset>
        <fieldset>
          <legend className="screen_out">저장 및 미리보기 버튼</legend>
          <div className="bunddle_preview">
              <button type="button" className="btn_preview" onClick={this.handlePreview}>미리보기<span className="ico_blog">새창으로 열기</span></button>
              <TButton onClick={this.handleSave} initialValues={initialSelected} currentValues={selected} />
          </div>
        </fieldset>
      </form>
    )
  }
}

MenubarForm.propTypes = {};
MenubarForm.defaultProps = {};

export default MenubarForm;
